// extracted by mini-css-extract-plugin
module.exports = {"cardStyle":"CategoriesPage_cardStyle__2tOvy","textName":"CategoriesPage_textName__396i5","heightCard":"CategoriesPage_heightCard__3WGQe"};